<template>
  <div class="products">
    <div class='products-title'>超声波流量计<p class="titleLine"></p></div>
    <ProductItem
        v-for="product in products"
        :key="product.id"
        :product="product"
    />
  </div>
</template>

<script>
import ProductItem from '@/components/ProductItem.vue'
export default {
  name: "Products",

  components: {
    ProductItem
  },
  data() {
    return {
      products: [
        // 填充你的产品数据
        { id: 1, // 每个产品通常有一个唯一的ID
        title: 'SC-UFM型超声波气体流量计1',
        date: '2023-04-01', // 日期格式可以根据需要调整
        image: require('../assets/productimg.png') // 图片路径，使用require引入静态资源
  },
    {
      id: 2,
          title: 'SC-UFM型超声波气体流量计2',
        date: '2023-03-15',
        image: require('../assets/productimg.png')
    },
        {
          id: 3,
          title: 'SC-UFM型超声波气体流量计3',
          date: '2023-03-15',
          image: require('../assets/productimg.png')
        },
        {
          id: 4,
          title: 'SC-UFM型超声波气体流量计4',
          date: '2023-03-15',
          image: require('../assets/productimg.png')
        },
      ]
    }
  }
}
</script>

<style scoped>
.products {
  width: 90%;
  margin: 15vw auto 22vw auto;
  text-align: left;
}
.products-title {
  color: #333333;
  font-size: 5vw;
  margin-bottom: 8vw;
  position: relative;
}
.titleLine {
  margin-top: 0.9375vw;
  width: 10vw;
  height: 0.5625vw;
  background-color: #448CD3;
}
@media (min-width: 768px) {
  .products {
    width: 680px;
    margin: 80px auto 120px auto;
  }
  .products-title {
    font-size: 30px;
    margin-bottom: 50px;
  }
  .titleLine {
    margin-top: 5px;
    width: 60px;
    height: 3px;
    background-color: #448CD3;
  }
  @media (min-width: 960px) {
    .products {
      width: 900px;
    }

  }

  @media (min-width: 1200px) {
    .products {
      width: 1200px;
    }

  }

}
</style>